<script lang="ts" setup>
withDefaults(
  defineProps<{
    value?: string | number
  }>(),
  { value: 0 }
)
</script>

<template>
  <div
    class="
      absolute -right-1.5 -top-1.5 flex size-[18px] items-center justify-center rounded-full
      bg-main-red text-center text-white
    "
  >
    <span v-if="value" class="text-[11px] leading-5">
      {{ value }}
    </span>
  </div>
</template>
